module.exports = __webpack_public_path__ + "static/media/taurus.c114f218.svg";